import React, { Suspense, useEffect, useRef, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import Test from "../pages/Test";
import Payment from "../portal/Rapport";
import LoginPartner from "../pages/LoginPartner";
import OverrideRoutes from "./routes/OverrideRoutes";
import OldRoutes, { navigateWorkspace } from "./routes/OldRoutes";
import NewRoutes from "./routes/NewRoutes";
import FolderPortal from "../portal/FolderPortal";
import SmsPortal from "../portal/SmsPortal";
import Rapport from "../portal/Rapport";
import InvoiceSecuredSign from "../portal/InvoiceSecuredSign";
const Entree = React.lazy(() => import("../pages/Entree"));
const Login = React.lazy(() => import("../pages/Login"));
const ProtectedRoute = React.lazy(() => import("../auth/ProtectedRoute"));
const Redirect = React.lazy(() => import("../pages/Redirect"));
const Setup = React.lazy(() => import("../pages/Setup"));
const InvoiceSign = React.lazy(() => import("../portal/InvoiceSign"));
const Signin = React.lazy(() => import("../pages/Signin"));
const NotFound = React.lazy(() => import("../pages/NotFound"));
const StripeSuccess = React.lazy(() => import("../pages/StripeSuccess"));
const OecForm = React.lazy(() => import("../pages/OecForm"));

const RoutesManager = ({
  navigateWorkspace,
  actualpage,
  version,
  userData,
  orgData,
  workspaceData,
  handleLoginAs,
  stripeConnectInstance,
  refreshFolders,
  handleLogout,
  masterData,
}) => {
  return (
    <div className="pointer-events-auto h-full w-full overflow-auto">
      <Routes>
        <Route
          path="/"
          element={<Redirect navigateWorkspace={navigateWorkspace} />}
        />
        <Route
          path="/entree"
          element={<Entree navigateWorkspace={navigateWorkspace} />}
        />
        <Route
          path="/login"
          element={
            <Login
              userData={userData}
              navigateWorkspace={navigateWorkspace}
              handleLogout={handleLogout}
            />
          }
        />
        <Route
          path="/login-partner"
          element={<LoginPartner navigateWorkspace={navigateWorkspace} />}
        />
        <Route
          path="/signin"
          element={<Signin navigateWorkspace={navigateWorkspace} />}
        />
        <Route
          path="/stripe-success"
          element={<StripeSuccess navigateWorkspace={navigateWorkspace} />}
        />
        <Route
          path="/test"
          element={<Test navigateWorkspace={navigateWorkspace} />}
        />
        <Route
          path="/oec-form"
          element={<OecForm navigateWorkspace={navigateWorkspace} />}
        />
        <Route
          path="/invoice-sign/:id"
          element={<InvoiceSign navigateWorkspace={navigateWorkspace} handleLogout={handleLogout} />}
        />
        <Route
          path="/invoice-sign"
          element={<InvoiceSecuredSign navigateWorkspace={navigateWorkspace} handleLogout={handleLogout} />}
        />
        <Route
          path="/rapport/:id"
          element={
            <Rapport
              navigateWorkspace={navigateWorkspace}
              userData={userData}
            />
          }
        />
        <Route
          path={"/folderportal/:id"}
          element={
            <FolderPortal
              navigateWorkspace={(path) => navigateWorkspace(path, orgData)}
            />
          }
        />{" "}
        <Route
          path={"/smsportal/:id"}
          element={
            <SmsPortal
              navigateWorkspace={(path) => navigateWorkspace(path, orgData)}
            />
          }
        />
        <Route
          path={"/imp-portal/folderportal/:id"}
          element={
            <FolderPortal
              navigateWorkspace={(path) => navigateWorkspace(path, orgData)}
              impersonate={true}
            />
          }
        />
        <Route
          path={"/imp-portal/rapport/:id"}
          element={
            <Rapport
              navigateWorkspace={(path) => navigateWorkspace(path, orgData)}
              impersonate={true}
            />
          }
        />
        <Route
          path="/setup"
          element={
            <ProtectedRoute
              needs_org={false}
              navigateWorkspace={navigateWorkspace}
            >
              <Setup navigateWorkspace={navigateWorkspace} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/imp/:id/workspace/:id/*"
          element={
            <OverrideRoutes
              navigateWorkspace={navigateWorkspace}
              userData={userData}
              orgData={orgData}
              workspaceData={workspaceData}
              refreshFolders={refreshFolders}
              masterData={masterData}
            ></OverrideRoutes>
          }
        />
        <Route
          path="/workspace/:id/*"
          element={
            <NewRoutes
              navigateWorkspace={navigateWorkspace}
              actualpage={actualpage}
              version={version}
              userData={userData}
              orgData={orgData}
              workspaceData={workspaceData}
              handleLoginAs={handleLoginAs}
              refreshFolders={refreshFolders}
              masterData={masterData}
            ></NewRoutes>
          }
        />
        <Route
          path="/*"
          element={
            <OldRoutes
              navigateWorkspace={navigateWorkspace}
              actualpage={actualpage}
              version={version}
              userData={userData}
              orgData={orgData}
              workspaceData={workspaceData}
              handleLoginAs={handleLoginAs}
              stripeConnectInstance={stripeConnectInstance}
              refreshFolders={refreshFolders}
              masterData={masterData}
            ></OldRoutes>
          }
        />
        <Route
          path="*"
          element={
            <NotFound
              navigateWorkspace={navigateWorkspace}
              actualpage={actualpage}
              version={version}
            />
          }
        />
      </Routes>
    </div>
  );
};

export default RoutesManager;
